<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconARBox"
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="42" height="42" viewBox="0 0 682.667 682.667"><defs><clipPath clipPathUnits="userSpaceOnUse" id="a"><path d="M0 512h512V0H0Z"/></clipPath><clipPath
        clipPathUnits="userSpaceOnUse" id="b"><path d="M0 512h512V0H0Z"/></clipPath></defs>
        <g clip-path="url(#a)" stroke="currentColor" transform="matrix(1.33333 0 0 -1.33333 0 682.667)"><path d="m0 0-236-87.407L-472 0" style="fill:none;stroke-width:40;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(492 403.407)"/></g>
        <path d="M0 0v-94" stroke="currentColor"
              style="fill:none;stroke-width:40;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
              transform="matrix(1.33333 0 0 -1.33333 341.333 261.333)"/>
        <g clip-path="url(#b)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)"><path stroke="currentColor" d="M0 0c0 28.719-23.281 52-52 52h-42V-90h42c28.719 0 52 23.281 52 52z" style="fill:none;stroke-width:40;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(492 110)"/>
            <path stroke="currentColor" d="M0 0h106v-1.008l-55-53.21v-.983s62-26.772 62-48.071C113-124.572 95.336-142 74.037-142H0"
                  style="fill:none;stroke-width:40;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                  transform="translate(212 162)"/>
            <path fill="currentColor"
                d="m0 0 216-79.999v-172.153c14.854-4.437 28.423-11.877 40-21.618v221.611L0 42.656l-256-94.815v-322.247l171-63.334v42.656l-131 48.518v266.567z"
                style="fill-opacity:1;fill-rule:nonzero;stroke:none" transform="translate(256 469.344)"/></g></svg>
</template>

<style scoped lang="scss">

</style>
